// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".a-media__wrapper[data-v-b04603b4]{width:100%}.image-caption[data-v-b04603b4]{margin-top:10px}", ""]);
// Exports
module.exports = exports;
